import _ from 'lodash';
import { Activity, ActivityTypes, PendingActivityTypes } from 'constants/activity.constants';
import {
	API_GET_BALANCES_ACTIVITIES,
	API_GET_BALANCE_BY_ID,
	API_GET_COMPANY_ACTIVITIES,
} from 'constants/db.constants';
import API from 'services/api.services';
import {
	setActivities,
	setLoading,
	setStartLoadingActivities,
	getActivities,
} from 'state/reducers/activity.reducers';
import { format } from 'date-fns';
import { store } from 'state/store';
import { timing } from 'constants/ui.constants';
import { convertType } from 'constants/convert.constants';
import { setWithdrawalRequests } from 'state/reducers/requests.reducers';
import { isDigitalDepositAllowed } from './balance.services';
import { BalanceDepositType } from 'constants/balance.constants';

export function getActivitiesAsync(companyId: number | undefined, startDate: Date, endDate: Date, limit?: number) {
	return async (dispatch: any) => {
		dispatch(setStartLoadingActivities());
		dispatch(setLoading(true));
		const paramsSetting = {
			companyId: companyId || 0,
			startDate: format(startDate, timing.DATE_FOR_SERVICE),
			endDate: format(endDate, timing.DATE_FOR_SERVICE),
		};
		limit && _.assign(paramsSetting, { limit });
		await API.getInstance()
			.post(API_GET_COMPANY_ACTIVITIES, paramsSetting)
			.then((response) => {
				const activities = parseActivities(response.data, !!limit);
				dispatch(setActivities(activities as Activity[]));
				dispatch(setLoading(false));
			})
			.catch((error) => {
				dispatch(setLoading(false));
			});
	};
}

export function getBalancesActivityByCompanyId(companyId: number) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		const paramsSetting = {
			companyId,
		};

		await API.getInstance()
			.post(API_GET_BALANCES_ACTIVITIES, paramsSetting)
			.then((response) => {
				dispatch(setLoading(false));
				dispatch(setWithdrawalRequests(_.get(response, 'data.withdrawalsRequests', [])));
			})
			.catch((error) => {
				dispatch(setLoading(false));
			});
	};
}

export function getBalanceActivityById(balanceId: string) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		const paramsSetting = {
			balanceId,
		};
		try {
			let res = await API.getInstance().get(API_GET_BALANCE_BY_ID, paramsSetting);
			dispatch(setLoading(false));
			return res?.data;
		} catch (e: any) {
			dispatch(setLoading(false));
		}
	};
}

export const parseActivities = (response: any, limit: boolean) => {
	try {
		let activities: object[] = [];
		_.values(ActivityTypes).forEach((type) => {
			let arr: object[] = [];
			if (_.isArray(response[type])) {
				response[type].forEach((el) => {
					let elm = { ...el, balanceType: el.type };
					elm.type = type;
					if (_.isEqual(type, ActivityTypes.conversionActivities)) {
						elm.transactionType = PendingActivityTypes.conversion;
						elm.createdByContactName =
							(elm?.contact?.firstName || '') + ' ' + (elm?.contact?.lastName || '');
						elm.approvedByContactName =
							(elm?.contact?.firstName || '') + ' ' + (elm?.contact?.lastName || '');
						elm.currency = _.isEqual(el.fixedSide, convertType.sell) ? el?.sellCurrency : el?.buyCurrency;
					} else {
						elm.createdByContactName =
							(elm?.createdBy?.firstName || '') + ' ' + (elm?.createdBy?.lastName || '');
						elm.approvedByContactName =
							(elm?.approvedBy?.firstName || '') + ' ' + (elm?.approvedBy?.lastName || '');
						elm.currency = el?.currency;
					}
					arr.push(elm);
				});
			}
			activities = activities.concat(arr);
		});
		return limit ? _.orderBy([...activities], ['updatedAt'], ['desc']) : activities;
	} catch (e) {
		return [];
	}
};

export function getLast24HoursDigitalActivities(): Activity[] {
	const digitalActivities: Activity[] = getActivities(store.getState());

	const now = Date.now();
	const twentyFourHoursAgo = now - 24 * 60 * 60 * 1000;

	return digitalActivities.filter((activity) => {
		if (!activity.createdAt || activity.depositType !== BalanceDepositType.Digital) return false;
		const activityTime = new Date(activity.createdAt).getTime();
		return activityTime > twentyFourHoursAgo && activityTime <= now;
	});
}

export function getDailyDigitalBalance(): number {
	const digitalActivities: Activity[] = getLast24HoursDigitalActivities();
	return digitalActivities.reduce((acc, activity) => acc + (activity.amount || 0), 0);
}
